import {Link} from "react-router-dom";

const Home = () => {
    return (
        <div>
            <Link to="/tournaments">Tournament List</Link>
        </div>
    );
}

export default Home;
